(function ($) {
  'use strict';

  $(function () {
    var $mealBtns = $('.bb-meal-btn');
    var $capBtns = $('.bb-cap-btn');
    var $slotEls = $('.bb-plan-slot');
    if (!$mealBtns.length || !$capBtns.length) return;

    var meals = { b: true, l: true, d: true };
    var capsDay = 2;
    var opts = [['b', 'Breakfast', '🌅'], ['l', 'Lunch', '☀️'], ['d', 'Dinner', '🌙']];
    var pref2 = ['b', 'd', 'l'];
    var pref1 = ['d', 'b', 'l'];

    var $planCapsEl = $('#bb-plan-caps');
    var $planCodeEl = $('#bb-plan-code');
    var $planDaysEl = $('#bb-plan-days');
    var $planNoteEl = $('#bb-plan-note');

    function render() {
      var chosen = (capsDay === 2 ? pref2 : pref1).filter(function (k) { return meals[k]; }).slice(0, capsDay);
      var n = chosen.length;
      var code = opts.map(function (o) { return chosen.indexOf(o[0]) !== -1 ? '1' : '0'; }).join('-');

      $planCapsEl.text(String(n) + ' capsule' + (n === 1 ? '' : 's') + ' / day');
      $planCodeEl.text(code);
      $planDaysEl.text(n ? String(Math.floor(60 / n)) : '-');
      $planNoteEl.text(
        n < capsDay
          ? "You've selected fewer meals than capsules - berberine should always go with food, so we've placed " + n + "."
          : (capsDay === 1
            ? 'Take it with your largest meal. Move to 2 a day after the first week if it sits well.'
            : 'One with each of your two main meals, spaced 6+ hours apart.')
      );

      $slotEls.each(function (i) {
        var $slot = $(this);
        var key = opts[i][0];
        var take = chosen.indexOf(key) !== -1;
        $slot.attr('data-skip', take ? 'false' : 'true');
        $slot.css('background', take ? 'rgba(255,96,0,0.18)' : 'rgba(255,255,255,0.06)');
        var $pillsWrap = $slot.find('.pd-dose__slot-pills');
        var $nEl = $slot.find('.pd-dose__slot-n');
        var $whyEl = $slot.find('.bb-plan-slot__why');
        $pillsWrap.empty();
        if (take) {
          $pillsWrap.append('<span class="pd-dose__pill"></span>');
          if ($nEl.length) { $nEl.prop('hidden', false).text('1'); }
          if ($whyEl.length) $whyEl.prop('hidden', true);
        } else {
          $pillsWrap.append('<span class="pd-dose__slot-none">-</span>');
          if ($nEl.length) $nEl.prop('hidden', true);
          if ($whyEl.length) $whyEl.prop('hidden', false).text(meals[key] ? 'skip' : 'no meal');
        }
      });
    }

    $mealBtns.each(function () {
      var $btn = $(this);
      $btn.on('click', function () {
        var key = $btn.data('meal');
        meals[key] = !meals[key];
        $btn.toggleClass('on', meals[key]);
        $btn.attr('aria-pressed', meals[key] ? 'true' : 'false');
        render();
      });
    });

    /* tapping a meal block in the plan does the same as its meal button above */
    $slotEls.each(function (i) {
      var $slot = $(this);
      var key = opts[i][0];
      $slot.attr({ role: 'button', tabindex: '0' }).css('cursor', 'pointer');
      function toggle() {
        meals[key] = !meals[key];
        $mealBtns.filter(function () { return $(this).data('meal') === key; })
          .toggleClass('on', meals[key]).attr('aria-pressed', meals[key] ? 'true' : 'false');
        render();
      }
      $slot.on('click', toggle).on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    $capBtns.each(function () {
      var $btn = $(this);
      $btn.on('click', function () {
        capsDay = parseInt($btn.data('caps'), 10);
        $capBtns.each(function () { $(this).toggleClass('selected', this === $btn[0]); });
        render();
      });
    });

    render();
  });
})(jQuery);
